export const menuItems = [
  {
    title: 'planBid',
    path: '/',
    id: 'menu1',
    icon: false,
    subItems: [
      {
        title: 'pairingPackage',
        path: '/pairing-package',
        icon: false,
        id: 'sub11'
      },
      {
        title: 'pairingDashboard',
        path: '/pairing-dashboard',
        icon: false,
        id: 'sub12'
      },
      {
        title: 'pairingList',
        path: '/pairing-list',
        icon: false,
        id: 'sub13'
      },
      {
        title: 'dmbReports',
        path: '/dbm',
        icon: false,
        id: 'sub14'
      },
      {
        title: 'line',
        path: '',
        icon: false,
        id: 'subLine1'
      },
      {
        title: 'sdoPage',
        path: '/sdo-landing',
        icon: false,
        id: 'sub15'
      },
      {
        title: 'frlRequest',
        path: 'https://forms.office.com/Pages/ResponsePage.aspx?id=34MdSZEQ-EC8-bES-aNfzwWETOO7TPBKutXUOdZVm-xUOFEzT1c4NEdVM1BJSElBN01ETDY0Rks0Qy4u',
        icon: false,
        id: 'sub16'
      },
      {
        title: 'bankedDeadhead',
        path: 'https://forms.office.com/r/uthTgZ2Gyh',
        icon: false,
        id: 'sub17'
      }
    ]
  },
  {
    title: 'flySchedule',
    path: '/',
    icon: false,
    id: 'menu2',
    subItems: [
      {
        title: 'blockMonth',
        path: '/my-block-month',
        icon: false,
        id: 'sub21'
      },
      {
        title: 'line',
        path: '',
        icon: false,
        id: 'subLine1'
      },
      {
        title: 'deadheadPremium',
        path: 'https://forms.office.com/Pages/ResponsePage.aspx?id=34MdSZEQ-EC8-bES-aNfz7hbYuwVWAlAmhwFQUUrSOpUQjQ5MVlKNk5ONjlYQkdENVhJUlRDS0Y0NS4u',
        icon: false,
        id: 'sub22'
      },
      {
        title: 'line',
        path: '',
        icon: false,
        id: 'subLine1'
      },
      {
        title: 'ebookoff',
        path: 'https://forms.office.com/Pages/ResponsePage.aspx?id=34MdSZEQ-EC8-bES-aNfz0YD7_hsOS9FqRfj1nfcUqZUMENJMlVPMjM4WkxPN1UxU1o5QkxBVDNLQi4u',
        icon: false,
        id: 'sub23'
      },
      {
        title: 'line',
        path: '',
        icon: false,
        id: 'subLine1'
      },
      {
        title: 'simSchedule',
        path: '/sim-schedule',
        icon: false,
        id: 'sub21'
      },
      {
        title: 'line',
        path: '',
        icon: false,
        id: 'subLine1'
      },
      {
        title: 'tbc',
        path: 'https://forms.cloud.microsoft/Pages/ResponsePage.aspx?id=34MdSZEQ-EC8-bES-aNfz0YD7_hsOS9FqRfj1nfcUqZUNkQ2RE45MUtWODVCVDNWT1NVMlA0RUNFVy4u',
        icon: false,
        id: 'sub24'
      }
    ]
  },
  {
    title: 'SupportPage',
    path: '/',
    icon: false,
    id: 'menu3',
    subItems: [
      {
        title: 'howToSyncPage',
        path: '/how-to-sync-cal',
        icon: false,
        id: 'sub62'
      },
      {
        title: 'faqs',
        path: '/faqs',
        icon: false,
        id: 'sub61'
      },
      {
        title: 'acronyms',
        path: '/acronyms',
        icon: false,
        id: 'sub63'
      },
      {
        title: 'helpfulLinks',
        path: 'https://aircanada.sharepoint.com/sites/myACcess/SitePages/Helpful-Links.aspx',
        icon: false,
        id: 'sub64'
      }
    ]
  },
  {
    title: 'quickLinks',
    path: '/',
    icon: false,
    id: 'menu4',
    subItems: [
      {
        title: 'pbsBidding',
        path: 'https://pbslink.aircanada.ca/',
        icon: false,
        id: 'sub41'
      },
      {
        title: 'blockMonthSchedule',
        path: 'https://aircanada.sharepoint.com/sites/FlightOps-Operaer/SitePages/Crew-Planning-Scheduling.aspx',
        icon: false,
        id: 'sub42'
      },
      {
        title: 'allBlocks',
        path: 'https://aircanada.sharepoint.com/sites/FlightOps-Operaer/PBS/Forms/PBS.aspx?id=/sites/FlightOps-Operaer/PBS/Blocks',
        icon: false,
        id: 'sub43'
      },
      {
        title: 'line',
        path: '',
        icon: false,
        id: 'subLine1'
      },
      {
        title: 'myFlightOpsHomepage',
        path: 'https://aircanada.sharepoint.com/sites/FlightOps-Operaer/SitePages/My-Flight-Ops.aspx',
        icon: false,
        id: 'sub46'
      },
      {
        title: 'apiCrewCare',
        path: 'https://api2.apicrewcare.com/Air-Canada/login.aspx',
        icon: false,
        id: 'sub47'
      },
    ]
  },
  {
    title: 'profile',
    icon: true,
    path: '/',
    id: 'login',
    subItems: [
      {
        title: 'settingsPage',
        path: '/settings',
        icon: false,
        id: 'sub31'
      },
      {
        title: 'line',
        path: '',
        icon: false,
        id: 'subLine1'
      },
      {
        title: 'logout',
        path: '/',
        icon: false,
        id: 'logout'
      }
    ]
  }
];

export const SIZES = {
  LARGE: 'one-row-view',
  MEDIUM: 'two-row-view',
  SMALL: 'three-row-view'
};

export const BREAKS = {
  LARGE: 93,
  MEDIUM: 109,
  SMALL: 129
};
